module.exports = __webpack_public_path__ + "static/media/daily-planner.12d7dda2.png";